/* eslint-disable no-unreachable */
/* eslint-disable prefer-template */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Marquee from "react-fast-marquee";
import './style.scss'

const ProjectRaise = () => {
  const listIdoPriceHome =
    [
      {
        "keyword": "qorbi",
        "symbol": "QORBI",
        "name": "Qorbi World",
        "logoUrl": "/images/new-home/1.png",
        "idoPrice": 0.02,
        "currentPrice": 0.031,
        "isOldIDo": false
      },
      {
        "keyword": "ccl",
        "symbol": "CCL",
        "name": "Cyclean",
        "logoUrl": "/images/new-home/2.png",
        "idoPrice": 0.035,
        "currentPrice": 0.036,
        "isOldIDo": false
      },
      {
        "keyword": "blu",
        "symbol": "BLU",
        "name": "BlueSpade",
        "logoUrl": "/images/new-home/3.png",
        "idoPrice": 1,
        "currentPrice": 1.48,
        "isOldIDo": false
      },
      {
        "keyword": "kayen",
        "symbol": "KAYEN",
        "name": "Kayen Protocol",
        "logoUrl": "/images/new-home/4.png",
        "idoPrice": 0.1136,
        "currentPrice": 0.1791,
        "isOldIDo": false
      },
      {
        "keyword": "gx",
        "symbol": "GX",
        "name": "Grindery",
        "logoUrl": "/images/new-home/5.png",
        "idoPrice": 0.039,
        "currentPrice": 0.039,
        "isOldIDo": false
      },
      {
        "keyword": "kib",
        "symbol": "KIB",
        "name": "Kibble",
        "logoUrl": "/images/new-home/6.png",
        "idoPrice": 0.017,
        "currentPrice": 0.034,
        "isOldIDo": false
      },
      {
        "keyword": "nimo",
        "symbol": "NIMO",
        "name": "Nimo AI",
        "logoUrl": "/images/new-home/7.png",
        "idoPrice": 0.00024,
        "currentPrice": 0.00049,
        "isOldIDo": false
      },
      {
        "keyword": "blink",
        "symbol": "BLINK",
        "name": "Blink Game AI",
        "logoUrl": "/images/new-home/8.png",
        "idoPrice": 0.00015,
        "currentPrice": 0.000075,
        "isOldIDo": false
      },
      {
        "keyword": "cry",
        "symbol": "CRY",
        "name": "Cryptaine",
        "logoUrl": "/images/new-home/9.png",
        "idoPrice": 0.25,
        "currentPrice": 0.25,
        "isOldIDo": false
      },
      {
        "keyword": "fntio",
        "symbol": "FNTIO",
        "name": "FNT Crypto",
        "logoUrl": "/images/new-home/10.jpg",
        "idoPrice": 0.02,
        "currentPrice": 0.0313,
        "isOldIDo": false
      },
      {
        "keyword": "gmxp",
        "symbol": "GMXP",
        "name": "GamersXP",
        "logoUrl": "/images/new-home/11.png",
        "idoPrice": 0.004,
        "currentPrice": 0.0063,
        "isOldIDo": false
      },
      {
        "keyword": "papu",
        "symbol": "PAPU",
        "name": "Papu Games",
        "logoUrl": "/images/new-home/12.jpg",
        "idoPrice": 0.006,
        "currentPrice": 0.0058,
        "isOldIDo": false
      },
      {
        "keyword": "fusio",
        "symbol": "FUSIO",
        "name": "BlockGuard",
        "logoUrl": "/images/new-home/13.png",
        "idoPrice": 0.007,
        "currentPrice": 0.007753,
        "isOldIDo": false
      },
      {
        "keyword": "trn",
        "symbol": "TRN",
        "name": "T3RN",
        "logoUrl": "/images/new-home/14.png",
        "idoPrice": 0.5,
        "currentPrice": 2,
        "isOldIDo": false
      },
      {
        "keyword": "ilmt",
        "symbol": "iLMT",
        "name": "iLuminaryAI",
        "logoUrl": "/images/new-home/15.png",
        "idoPrice": 0.11,
        "currentPrice": 0.072,
        "isOldIDo": false
      },
      {
        "keyword": "tix",
        "symbol": "TIX",
        "name": "Timeworx",
        "logoUrl": "/images/new-home/16.png",
        "idoPrice": 0.0275,
        "currentPrice": 0.3887,
        "isOldIDo": false
      },
      {
        "keyword": "haio",
        "symbol": "HAIO",
        "name": "HAiO",
        "logoUrl": "/images/new-home/17.png",
        "idoPrice": 0.03,
        "currentPrice": 0.04436,
        "isOldIDo": false
      },
      {
        "keyword": "ggc",
        "symbol": "GGC",
        "name": "Grand Gangsta City",
        "logoUrl": "/images/new-home/18.png",
        "idoPrice": 0.006,
        "currentPrice": 0.01399,
        "isOldIDo": false
      },
      {
        "keyword": "pvt",
        "symbol": "PVT",
        "name": "Punkvism",
        "logoUrl": "/images/new-home/19.png",
        "idoPrice": 0.002625,
        "currentPrice": 0.003396,
        "isOldIDo": false
      },
      {
        "keyword": "therapi",
        "symbol": "THRAI",
        "name": "Therapi",
        "logoUrl": "/images/new-home/20.png",
        "idoPrice": 0.018,
        "currentPrice": 0.01979,
        "isOldIDo": false
      },
      {
        "keyword": "lendr-fi",
        "symbol": "RWAL",
        "name": "Lendr.fi",
        "logoUrl": "/images/new-home/21.png",
        "idoPrice": 0.03,
        "currentPrice": 0.047,
        "isOldIDo": false
      },
      {
        "keyword": "west-tech",
        "symbol": "WST",
        "name": "WestTech",
        "logoUrl": "/images/new-home/22.png",
        "idoPrice": 0.03,
        "currentPrice": 0.06,
        "isOldIDo": false
      },
      {
        "keyword": "aiquant",
        "symbol": "AIQ",
        "name": "AIQuant",
        "logoUrl": "/images/new-home/23.png",
        "idoPrice": 0.05,
        "currentPrice": 0.07575,
        "isOldIDo": false
      },
      {
        "keyword": "zodax",
        "symbol": "ZODX",
        "name": "Zodax",
        "logoUrl": "/images/new-home/24.png",
        "idoPrice": 0.001,
        "currentPrice": 0.0013,
        "isOldIDo": false
      }
    ];

  let arr1EndIdo = listIdoPriceHome.slice(0, 16);
  let arr2EndIdo = listIdoPriceHome.slice(16);

  const Item = (item: any) => {
    return (
      <div
        className="colum w-10 marquee-item"
      >
        <div className="box-ido-raise">
          <div className="icon-raise">
            <img src={item.logoUrl} alt="" />
          </div>
          <div className="name-raise">{item.name}</div>
          <div className="number-raise">
            <div
              className={
                Number(((item.currentPrice / item.idoPrice) * 100).toFixed(1)) <
                  100
                  ? "down-price"
                  : Number(
                    ((item.currentPrice / item.idoPrice) * 100).toFixed(1)
                  ) > 100
                    ? "up-price"
                    : ""
              }
            >
              {((item.currentPrice / item.idoPrice) * 100).toFixed(1)}%
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="main-setion new-raise">
        <div className="main-title">
          <p className="desc">
            Helping the most successful projects raise funding
          </p>
        </div>
        <div className="table-project-raise">
          <div className="columns">
            <Marquee
              gradient
              gradientWidth={150}
              autoFill
              pauseOnHover
              speed={20}
              className="marquee-custom"
            >
              {arr1EndIdo.length !== 0 ? (
                arr1EndIdo.map((item: any, index: any) => <>{Item(item)}</>)
              ) : (
                <div className="colum w-10">{/* <Empty /> */}</div>
              )}
            </Marquee>
            <Marquee
              gradient
              gradientWidth={150}
              autoFill
              pauseOnHover
              speed={20}
              className="marquee-custom"
              direction="right"
            >
              {arr2EndIdo.length !== 0 ? (
                arr2EndIdo.map((item: any, index: any) => <>{Item(item)}</>)
              ) : (
                <div className="colum w-10">{/* <Empty /> */}</div>
              )}
            </Marquee>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProjectRaise;
